import { Link } from 'react-router';
import { useMyRsvps } from '../../events/queries';
import { EventCard } from './EventCard';
import { EmptyState, ErrorState, Heading, Spinner, Stack, Text } from '../../ui';

/**
 * The events the caller has RSVP'd to, soonest first.
 *
 * Cancelled events the caller planned to attend stay in the list so a called-off event is visible
 * rather than silently gone.
 *
 * @returns The my-RSVPs screen.
 */
export function MyRsvpsPage(): React.JSX.Element {
  const { data, isPending, isError, error, refetch } = useMyRsvps();

  return (
    <Stack gap="xl">
      <Heading level={1}>My RSVPs</Heading>

      {isPending && (
        <Stack gap="md" align="center">
          <Spinner label="Loading your RSVPs" />
          <Text muted>Loading…</Text>
        </Stack>
      )}

      {isError && <ErrorState message={error.message} onRetry={() => void refetch()} />}

      {!isPending && !isError && data.length === 0 && (
        <EmptyState
          title="No RSVPs yet"
          description="Events you say you are going to or interested in show up here."
          action={
            <Link className="gm-button gm-button--primary" to="/events">
              Discover events
            </Link>
          }
        />
      )}

      {!isPending && !isError && data.length > 0 && (
        <div className="gm-event-list">
          {data.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      )}
    </Stack>
  );
}
